import { Container, makeStyles, Paper } from "@material-ui/core";

import { Cooperation } from "../../gardener/gardener.model";
import { LevelIconAndText } from "../your-level/LevelIconAndText";
import { determineLevelText, determineNextCooperationLevel, determineNumberOfTasksBenefit, determinePriorityBenefit } from "../utility";
import { UnorderedList } from "../../components/unordered-list/UnorderedList";
import { BlockingProgressItemHeader } from "./BlockingProgressHeader";

const useStyles = makeStyles(theme => ({
    card: {
        overflow: "hidden",
        padding: "24px",

        "& > *": {
            marginBottom: "24px",

            "&:last-child": {
                marginBottom: 0,
            },
        },
    },
    paragraph: {
        fontSize: "16px",
        fontWeight: 400,
        color: "#4A4A4A",

        "& > span": {
            fontWeight: 600,
        },

        [theme.breakpoints.down(500)]: {
            textAlign: "center",
        },
    },
}));

interface LevelDownItemProps {
    cooperationLevel: Exclude<Cooperation["level"], "platin">;
    tasksUntilNextLevel: number;
    onClose?: () => void;
}

export const LevelDownItem = (props: LevelDownItemProps) => {
    const classes = useStyles();
    const { cooperationLevel, tasksUntilNextLevel, onClose } = props;

    const numberOfTasksBenefit = determineNumberOfTasksBenefit(cooperationLevel);
    const priorityBenefit = determinePriorityBenefit(cooperationLevel);

    const nextCooperationLevel = determineNextCooperationLevel(cooperationLevel);
    const nextLevelText = determineLevelText(nextCooperationLevel);

    return (
        <Container maxWidth="sm" disableGutters>
            <Paper className={classes.card}>

                <BlockingProgressItemHeader onClose={onClose}>
                    Dit niveau er nu <LevelIconAndText cooperationLevel={cooperationLevel} />
                </BlockingProgressItemHeader>

                <div className={classes.paragraph}>
                    Du har ikke løst nok opgaver til at bevare dit tidligere niveau, men du er lige på grænsen og kan hurtigt blive {nextLevelText} igen 💪
                </div>

                <div className={classes.paragraph}>
                    Dine fordele er nu:
                    <UnorderedList>
                        <li>{numberOfTasksBenefit}</li>
                        <li>{priorityBenefit}</li>
                    </UnorderedList>
                </div>

                <div className={classes.paragraph}>
                    Løs <span>{tasksUntilNextLevel} {tasksUntilNextLevel !== 1 ? "opgaver" : "opgave"}</span> for
                    at nå <LevelIconAndText cooperationLevel={nextCooperationLevel} />
                </div>

            </Paper>
        </Container>
    );
};
